import React, { useState } from "react";

// mui components
import { Modal, Stack, Box, InputLabel } from "@mui/material";

import { useMaxLoanWarningLogMutation } from "../../../features/max-loan-warning-log/maxLoanWarningLogApiSlice";
// custom components
import Heading2 from "../../typography/heading-02";
import Heading6 from "../../typography/heading-06";
import Body1 from "../../typography/body-01";
import PrimaryButton from "../../buttons/primary-button";
import OutlinedTextInput from "../../custom-input/outlined-text-input";

// custom animations
import Lottie from "lottie-react";
import errorAnimation from "../../../assets/animations/error.json";

// custom styles
import styles from "./index.module.scss";
import Heading4 from "../../typography/heading-04";
import Heading5 from "../../typography/heading-05";

export default function MaxLoanModal({ open, maxLoanAmountConstant, handleClose, text, confirmText, requestedLoanAmount, setNewLoanAmount, handleNewLoanAmountChange }) {
	const [noAction, setNoAction] = useState(false)
	const [yesAction, setYesAction] = useState(false)

	const [maxLoanWarningLog] = useMaxLoanWarningLogMutation()
	
	const handleNoFlow = () => {
		setNoAction(true)
		setYesAction(false)
	}

	const handleYesFlow = () => {
		setYesAction(true)
		setNoAction(false)
	}

	const handleNewLoanAmount = (event) => {
		const newValue = event.target.value
		if(newValue > 0){
			setNewLoanAmount(event.target.value)
		}
	}

	const handleSaveAndContinue = () => {
		maxLoanWarningLog({
			loan_amount: requestedLoanAmount,
		}).unwrap().catch((err) => {
			console.log("max_loan_warning_override log error:", err)
		})
		handleNewLoanAmountChange()
		handleClose()
	}
	
	return (
		<Modal
			open={open}
			aria-labelledby="success modal"
			aria-describedby="success modal"
			disableAutoFocus={true}
			disableEscapeKeyDown={true}
		>
			<Stack
				direction="column"
				justifyContent="center"
				alignItems="center"
				className={styles.modalBodyContainer}
			>
				<Box className={styles.animationContainer}>
					<Lottie animationData={errorAnimation} loop={true} />
				</Box>

				<Stack
					direction="column"
					alignItems="center"
					className={styles.textContainer}
				>
					<Heading2
						text="Warning"
						extraClass={styles.successText}
						fontType="semibold"
					/>

					<Body1 text={text} extraClass={styles.successSubText} />
				</Stack>

				<Stack direction="row" className={styles.inputContainer}>
					<Stack direction="column" className={styles.inputContainer}>
						<InputLabel htmlFor="input-org-name">
							<Heading6
								text="Max Allowed Loan Amount"
								fontType="semibold"
								extraClass={styles.inputHeader}
							/>
						</InputLabel>

						<OutlinedTextInput
							id="input-org-name"
							placeholder="max loan amount"
							fullWidth={true}
							value={'$'+ maxLoanAmountConstant}
							handleChange={(event) => (event.target.value)}
							disabled
						/>
					</Stack>
				</Stack>
				<Stack direction={'row'} className={styles.yesNoAlignment}>
					<Stack direction={'column'} width={'150px'}>
						<PrimaryButton
							text="Yes"
							onClick={handleYesFlow}
							fullWidth={true}
						/>
						<Heading4
							text=""
							extraClass={styles.successText}
							fontType="semibold"
						/>
					</Stack>
					<Stack direction={'column'} width={'150px'}>
						<PrimaryButton
							text="No"
							onClick={handleNoFlow}
							fullWidth={true}
						/>
						{!noAction && !yesAction && <Heading5
							text="Press 'No' to correct your loan amount"
							extraClass={styles.successNewText}
							fontType="semibold"
						/>}
					</Stack>
					
					
				</Stack>
				
		  		{noAction ? <>
					<Stack direction="row" className={styles.inputContainer}>
						<Stack direction="column" className={styles.inputContainer}>
							<InputLabel htmlFor="input-org-name">
								<Heading6
									text={`Requested Loan Amount[$${requestedLoanAmount}.00]`}
									fontType="semibold"
									extraClass={styles.inputErrorHeader}
								/>
							</InputLabel>

							<OutlinedTextInput
								id="input-org-name"
								placeholder="Add corrected loan amount"
								fullWidth={true}
								handleChange={handleNewLoanAmount}
							/>
						</Stack>
					</Stack>

					<PrimaryButton
						text={confirmText ? confirmText : "OK"}
						onClick={handleSaveAndContinue}
						fullWidth={true}
					/>
				
				</> : null}

				{yesAction ? <>
					<Body1 text="You can Save and Continue, but please contact your Account Executive to submit a pre-submission exception request for this loan amount." extraClass={styles.successNewText} />

					<PrimaryButton
						text={confirmText ? confirmText : "OK"}
						onClick={handleSaveAndContinue}
						fullWidth={true}
					/>
				
				</> : null}
				
			</Stack>
		</Modal>
	);
}
